import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// import { InfoCircleOutlined } from '@ant-design/icons';
// import { defaultPrefix } from 'all-in-one-shared-api';
import { Button, Card, Divider, Form } from 'antd';
import styled from 'styled-components';
import { Wrapper } from 'pages/life/forget/styledComponents';
import RegisterCard from '../RegisterCard/RegisterCard';
// import regIcon from 'assets/images/register-icon.svg';
import { useLocation } from 'react-router-dom';
// import { ActionType, RegistrationFlowContext } from 'contexts/registration';
// import { RegistrationFormData } from 'contexts/registration/registrationFormData';
// import { useRegistrationStateQuery } from 'hooks/useRegistrationStateQuery';
// import { DEFAULT_DATE_FORMAT, disabledDate } from 'utils';
// import { IconTitle } from 'components';
import PolicyAndMemberIdModal from '../../forget/PolicyAndMemberIdModal';
import { revalidateAntdFormLanguageChanged } from '../../../../i18n';
// import { getBirthdayString } from 'utils/registration';
import { StyledTitle } from 'components/StyledTitle';
// import _get from 'lodash/get';
// import { useLifeUserRegister } from 'all-in-one-shared-api';
import { useContext } from 'react';
import { RegistrationFlowContext } from 'contexts/registration';
import ProgressSteps from '../components/ProgressSteps';
// import { use } from 'i18next';
const RegistrationCard = styled(Card)`
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
`;

// const FormWrapper = styled.div`
//   display: grid;
//   row-gap: 12px;
//   max-width: 510px;
// `;
type LifeCardPropList = {
  color?: string;
  arrow?: true;
  stateCode?: string;
  policynumber?: string;
  title?: string;
  name?: string;
  policyTitle?: string;
  alertsType?: string;
  alertsCode?: string;
  dueDate?: string;
  productCategory?: string;
  productCategoryUrl?: string;
  productCategoryEn?: string;
  productCategoryTC?: string;
  companyCode?: string;
  productName?: string;
  productNameTc?: string;
  policyStatusCode?: string;
  policyStatus?: string;
  policyStatusTc?: string;
  colour?: string;
  alertStateCode?: string;
  alertState?: string;
  alertStateTc?: string;
  policyNumber?: string;
  insuredName?: string;
  premiumDueDate?: string;
  salesUnitCode?: string;
}[];
interface LocationState {
  lifeCardData: LifeCardPropList;
  life: boolean;
}

function EbConfirm() {
  const location = useLocation();
  const { life } = (location.state as LocationState) ?? {};
  // const { lifeCardData } = (location.state as LocationState) ?? {};
  const lifeCardData = [
    {
      productCategory: 'LIFE',
      productCategoryUrl: 'https://repository.generali.com.hk/GenBravo/uat/icons/02-life-protection.svg',
      productCategoryEn: 'Life Protection',
      productCategoryTC: '人壽保障',
      productName: 'Concord Life Insurance Plan',
      productNameTc: 'Concord Life Insurance Plan',
      policyNumber: '83000049',
      insuredName: 'DUMMY-GIV-03000124 DUMMY-SUR-03000124',
      insuredNameTC: 'DUMMY-GIV-03000124 DUMMY-SUR-03000124',
      policyStatus: 'IF',
      policyStatusEN: 'Active',
      policyStatusTC: '生效',
      colour: 'GREEN',
      companyCode: '2',
      orderNo: 4,
    },
    {
      productCategory: 'LIFE',
      productCategoryUrl: 'https://repository.generali.com.hk/GenBravo/uat/icons/02-life-protection.svg',
      productCategoryEn: 'Life Protection',
      productCategoryTC: '人壽保障',
      productName: 'Concord Life Insurance Plan',
      productNameTc: 'Concord Life Insurance Plan',
      policyNumber: '83000049',
      insuredName: 'DUMMY-GIV-03000124 DUMMY-SUR-03000124',
      insuredNameTC: 'DUMMY-GIV-03000124 DUMMY-SUR-03000124',
      policyStatus: 'IF',
      policyStatusEN: 'Active',
      policyStatusTC: '生效',
      colour: 'GREEN',
      companyCode: '2',
      orderNo: 4,
    },
    {
      productCategory: 'LIFE',
      productCategoryUrl: 'https://repository.generali.com.hk/GenBravo/uat/icons/02-life-protection.svg',
      productCategoryEn: 'Life Protection',
      productCategoryTC: '人壽保障',
      productName: 'Concord Life Insurance Plan',
      productNameTc: 'Concord Life Insurance Plan',
      policyNumber: '83000049',
      insuredName: 'DUMMY-GIV-03000124 DUMMY-SUR-03000124',
      insuredNameTC: 'DUMMY-GIV-03000124 DUMMY-SUR-03000124',
      policyStatus: 'IF',
      policyStatusEN: 'Active',
      policyStatusTC: '生效',
      colour: 'GREEN',
      companyCode: '2',
      orderNo: 4,
    },
  ];
  // const [errorMessage, setErrorMessage] = useState<string>();
  const { t, i18n } = useTranslation();
  const { state } = useContext(RegistrationFlowContext);
  console.log('state.selfDefinedLoginId', state.selfDefinedLoginId);
  // const initialValues = useRegistrationStateQuery();
  // const [registrationState, setRegistrationState] = useState<RegistrationFormData>(initialValues);
  // const { dispatch } = useContext(RegistrationFlowContext);
  // const [mobilePrefix, setMobilePrefix] = useState(initialValues.countryCode || defaultPrefix);
  const navigate = useNavigate();
  // const dateFormat = DEFAULT_DATE_FORMAT;
  // const [snackbarMessage, setSnackbarMessage] = useState(initialValues.registerError || '');
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  // const emailRef = React.useRef<InputRef>(null);

  const [form] = Form.useForm();

  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [form, i18n.language]);

  // const handleCloseSnackbar = () => {
  //   setSnackbarMessage('');
  // };

  // const isMobileVerified = (mobile: string): boolean => {
  //   return !!registrationState.verifiedMobileNumber && mobile === registrationState.mobile;
  // };

  // Note(Anson Kan): I don't know how to type the `format` and where does it come from...
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // const onFinish = () => {};

  // const handleChange = (value: string) => {
  //   setMobilePrefix(value);
  // };

  // const showModal = () => {
  //   setIsModalVisible(true);
  // };
  const closeModel = () => {
    setIsModalVisible(false);
  };

  // const isEnglish = i18n.language === 'en';
  // const RegisterCardData: LifeCardPropList = [];
  return (
    <div>
      {/* <IconTitle title={t('launch.registerBtn')} level={2} icon={regIcon} /> */}
      <RegistrationCard
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '0',
        }}
      >
        <ProgressSteps activeStepIndex={2} />
        <div
          style={{
            // backgroundColor: 'pink',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <StyledTitle level={5} type="secondary" margin="0 0 24px 0">
            {t('registration.congratulations')}
          </StyledTitle>
          <StyledTitle level={5} type="secondary" margin="0 0 24px 0">
            {t('registration.added')}
          </StyledTitle>
        </div>
        <Wrapper style={{ backgroundColor: 'white', borderRadius: 0, width: '100%', border: 0 }}>
          <StyledTitle level={4}>{life ? t('registration.title1') : t('registration.title2')}</StyledTitle>
          <Divider />
          <RegisterCard data={lifeCardData} />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              // backgroundColor: 'pink',
            }}
          >
            <StyledTitle level={5} type="secondary" margin="0 0 24px 0">
              {t('registration.question1') ? t('registration.question1') : t('registration.question2')}
            </StyledTitle>
            <Button
              block
              type="default"
              size="large"
              onClick={() => navigate('/register/LifeRegistrationLanding')}
              style={{
                color: 'red',
                width: '80%',
                // backgroundColor: 'pink',
              }}
            >
              {t('registration.addedBtn')}
            </Button>
            <Button
              block
              type="primary"
              size="large"
              style={{ marginTop: '12px', width: '80%' }}
              onClick={() => navigate('/ebRegist')}
            >
              {t('registration.useBtn')}
            </Button>
          </div>
        </Wrapper>
      </RegistrationCard>
      <PolicyAndMemberIdModal isModalVisible={isModalVisible} handleModalClose={closeModel} />
    </div>
  );
}

export default EbConfirm;
